import { css } from 'styled-components';
import theme from '../../theme';

export const SvgStyles = ({ height, color, overColor }) => {
  return css`
    height: ${height || '20px'};

    & path {
      fill: ${color || theme.colors.white};
    }

    &:hover path {
      fill: ${overColor || theme.colors.red};
    }
  `;
};